var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Autocomplete, Divider, FormControlLabel, InputAdornment, InputLabel, Radio, TextField, Typography, styled, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { APPLICATION_SETTINGS, LanguageListAPI, PreviousDocumentFetchURL, RelationListAPI, VIContactPreferencePickListAPI, VIcreateRiderAPI, ValidateTechpackExpiryURL, appointmentDetailsGetByIdAPI, getRiderListByInstallBaseIdUrl, getVehicleInspectionDetails, sentOtpUrl, updateAssociateCustomerAPI, verifyOtpUrl } from '../../../api/url';
import { AddIcon } from '../../../assets/customIcons';
import { GreenVerifiedTick } from '../../../assets/images';
import { formatDate } from '../../../builderPackage/common/commonFunctions';
import { InputBox, MuiButton, MuiForm, MuiPopup, MuiStack, MuiUseForm } from '../../../components';
import { MuiCheckBox } from '../../../components/atoms/checkBox';
import { MuiIconButton } from '../../../components/atoms/iconButtonComponent';
import { MuiSelectComponent } from '../../../components/atoms/muiSelectComponent';
import { APISchema, EParentModuleName, ESystemName, E_Channel_Name, LOCAL_STORAGE_KEYS, timerCount } from '../../../constants';
import { getDocumentByIdAPIFunction, setDocDataUpdated, showLoader, showNotification } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setState, updateAPI } from '../../../redux/crudSlice';
import { useAppSelector } from '../../../store/hooks';
import { bajajPrimaryBlue } from '../../../theme/palette';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem, setLocalStorageItem } from '../../../utils/storageHelper';
import { GoogleAnlyticsErrorLog, createUILog, formatTime, handleServerSideErrors, handleServerSideErrorsForAnalytics } from '../../../utils/utils';
import { REG, validateContactNumber, validateEmail } from '../../../utils/validationHelper';
import ServiceDetailsComponent from '../serviceDetails/serviceDetailsComponent';
import CustomerAndInstallBaseSelect from './customerAndInstallBaseSelect';
import TechPackPopup from './techPackPopup';
var ECustomerType = /*#__PURE__*/ function (ECustomerType) {
    ECustomerType["Owner"] = "Owner";
    ECustomerType["Rider"] = "Rider";
    return ECustomerType;
}(ECustomerType || {});
var initialFValues = {
    relation: "",
    riderFirstName: "",
    riderLastName: '',
    ContactNumber: "",
    emailId: "",
    language: "",
    otp: "",
    contactPreferences: []
};
var MuiAutocomplete = styled(Autocomplete)(function (_ref) {
    var theme = _ref.theme;
    return {
        "& fieldset": {
            border: '1px solid #DEE4EB',
            boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#DEE4EB'
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #AFD5FF",
            borderRadius: "8px",
            boxShadow: "0px 0px 0px 4px rgba(54, 151, 255, 0.24), 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
        },
        '&.Mui-disabled': {
            backgroundColor: '#F4F7FA',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#DEE4EB'
            }
        }
    };
});
export default function SelectInstallbaseAndRider(props) {
    var _this = this;
    var _RiderDetailsList$dat, _RiderDetailsList$dat2, _VehiclesDetailsList$2, _RiderDetailsList$dat6, _RiderDetailsList$dat7, _ContactPreferrenceLi;
    var VehiclesDetailsList = props.VehiclesDetailsList, customerDetails = props.customerDetails, isCheckBoxVisible = props.isCheckBoxVisible, validateDocumentURL = props.validateDocumentURL, SystemName = props.SystemName, parentComponent = props.parentComponent, createDocumentURL = props.createDocumentURL, apiRequestPayload = props.apiRequestPayload, module = props.module, parentModuleDocumentId = props.parentModuleDocumentId, onSuccessfullDocumentCreate = props.onSuccessfullDocumentCreate, modifyDocumentURL = props.modifyDocumentURL, isDisabled = props.isDisabled, createAndEditFlow = props.createAndEditFlow, IsFromParentAPt = props.IsFromParentAPt, onVehicleSelect = props.onVehicleSelect;
    var dispatch = useDispatch();
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var applicationSetting = localStorage.getItem(APPLICATION_SETTINGS);
    var otpLength = applicationSetting ? JSON.parse(applicationSetting !== null && applicationSetting !== void 0 ? applicationSetting : "").data.OTPLength : 4;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _a = useAppSelector(function (state) { return state.crud; }), LanguageList = _a.LanguageList, RelationList = _a.RelationList, RiderDetailsList = _a.RiderDetailsList, ContactPreferrenceList = _a.ContactPreferrenceList, createVehicleInspectionData = _a.createVehicleInspectionData, documentDetailsGetById = _a.documentDetailsGetById, AssociateCustomerId = _a.AssociateCustomerId;
    var _b = useState(!isCheckBoxVisible ? VehiclesDetailsList[0] : {}), selectedVehicle = _b[0], setSelectedVehicle = _b[1];
    // const [customerType, setCustomerType] = useState<ECustomerType>(ECustomerType.Rider);
    var _c = useState(false), onClickRider = _c[0], setOnClickRider = _c[1];
    var _d = useState(false), openAddRiderPopup = _d[0], setOpenAddRiderPopup = _d[1];
    var _e = useState(), selectedRider = _e[0], setSelectedRider = _e[1];
    var _f = useState(false), isSendNotification = _f[0], setIsSendNotification = _f[1];
    var _g = useState(timerCount), counter = _g[0], setCounter = _g[1];
    var _h = useState(false), verifyOtp = _h[0], setVerifyOtp = _h[1];
    var _j = useState(false), isVerified = _j[0], setIsVerified = _j[1];
    var _k = useState(false), isCounterActive = _k[0], setIsCounterActive = _k[1];
    var _l = useState(true), errorMessage = _l[0], setErrorMessage = _l[1];
    var _m = useState(""), riderAssociateCustomerId = _m[0], setRiderAssociateCustomerId = _m[1];
    var _o = useState((_RiderDetailsList$dat = RiderDetailsList === null || RiderDetailsList === void 0 || (_RiderDetailsList$dat2 = RiderDetailsList.data) === null || _RiderDetailsList$dat2 === void 0 ? void 0 : _RiderDetailsList$dat2.IsMobileVerified) !== null && _RiderDetailsList$dat !== void 0 ? _RiderDetailsList$dat : false), riderVerifiedStatus = _o[0], setRiderVerifiedStatus = _o[1];
    var _p = useState(true), isShowSkeleton = _p[0], setShowSkeleton = _p[1];
    var documentId = useParams().documentId;
    var _q = useState(''), getInstallBaseId = _q[0], setInstallBaseId = _q[1];
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var _r = useState({
        open: false,
        heading: "",
        description: "",
        popupType: "info",
        declineButton: null,
        acceptButton: null,
        onClose: function () { return setTechPackPopup({
            open: false,
            heading: "",
            description: "",
            popupType: "info",
            declineButton: null,
            acceptButton: null,
            onClose: techPackPopup.onClose
        }); }
    }), techPackPopup = _r[0], setTechPackPopup = _r[1];
    var validate = function () {
        var fieldValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : values;
        var temp = _objectSpread({}, errors);
        if ("emailId" in fieldValues)
            temp.emailId = fieldValues.emailId ? !validateEmail(fieldValues.emailId) ? t("Enter valid Email Id") : "" : "";
        if ("relation" in fieldValues)
            temp.relation = fieldValues.relation ? "" : t("This field is required.");
        if ("riderFirstName" in fieldValues)
            temp.riderFirstName = fieldValues.riderFirstName ? "" : t("This field is required.");
        if ("riderLastName" in fieldValues)
            temp.riderLastName = fieldValues.riderLastName ? "" : t("This field is required.");
        if ("ContactNumber" in fieldValues)
            temp.ContactNumber = fieldValues.ContactNumber ? validateContactNumber(fieldValues.ContactNumber, 10) ? t("Enter valid Mobile no.") : "" : t("This field is required.");
        setErrors(_objectSpread({}, temp));
        if (fieldValues === values)
            return Object.values(temp).every(function (x) { return x === ""; });
    };
    var _s = MuiUseForm(initialFValues, true, validate), values = _s.values, errors = _s.errors, setErrors = _s.setErrors, setValues = _s.setValues, handleInputChange = _s.handleInputChange;
    useEffect(function () {
        var _RiderDetailsList$dat3;
        setRiderVerifiedStatus(RiderDetailsList === null || RiderDetailsList === void 0 || (_RiderDetailsList$dat3 = RiderDetailsList.data) === null || _RiderDetailsList$dat3 === void 0 ? void 0 : _RiderDetailsList$dat3.IsMobileVerified);
        getRelationPickList();
    }, []);
    useEffect(function () {
        if (VehiclesDetailsList && (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.length) > 0) {
            var _VehiclesDetailsList$;
            if (!((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) == "Create" || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) == "Create" || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) == "Create" && !IsFromParentAPt)) {
                setSelectedVehicle(VehiclesDetailsList[0]);
            }
            if ((_VehiclesDetailsList$ = VehiclesDetailsList[0]) !== null && _VehiclesDetailsList$ !== void 0 && _VehiclesDetailsList$.InstallBaseId && SystemName != ESystemName.Appointment) {
                var _documentDetailsGetBy;
                if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy = documentDetailsGetById.data) !== null && _documentDetailsGetBy !== void 0 && _documentDetailsGetBy.AssociateCustomerId) {
                    getRidersList(VehiclesDetailsList[0].InstallBaseId);
                }
                else {
                    setInstallBaseId(VehiclesDetailsList[0].InstallBaseId);
                }
            }
        }
    }, [(createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) === 'Update', (_VehiclesDetailsList$2 = VehiclesDetailsList[0]) === null || _VehiclesDetailsList$2 === void 0 ? void 0 : _VehiclesDetailsList$2.InstallBaseId]);
    useEffect(function () {
        if (documentDetailsGetById && documentDetailsGetById.data) {
            var _documentDetailsGetBy2, _documentDetailsGetBy3, _documentDetailsGetBy4, _documentDetailsGetBy5;
            setRiderAssociateCustomerId(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.AssociateCustomerId);
            dispatch(setState({
                key: "AssociateCustomerId",
                value: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.AssociateCustomerId
            }));
            if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy4 = documentDetailsGetById.data) !== null && _documentDetailsGetBy4 !== void 0 && _documentDetailsGetBy4.AssociateCustomerId) {
                setOnClickRider(true);
            }
            setErrorMessage(false);
            setInstallBaseId(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.InstallBaseId);
        }
    }, [documentDetailsGetById]);
    useEffect(function () {
        var _documentDetailsGetBy6;
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy6 = documentDetailsGetById.data) !== null && _documentDetailsGetBy6 !== void 0 && _documentDetailsGetBy6.AssociateCustomerId) {
            var _RiderDetailsList$dat4;
            var selectdRiderItem = RiderDetailsList === null || RiderDetailsList === void 0 || (_RiderDetailsList$dat4 = RiderDetailsList.data) === null || _RiderDetailsList$dat4 === void 0 ? void 0 : _RiderDetailsList$dat4.find(function (item) {
                var _documentDetailsGetBy7;
                return item.id == (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy7 = documentDetailsGetById.data) === null || _documentDetailsGetBy7 === void 0 ? void 0 : _documentDetailsGetBy7.AssociateCustomerId);
            });
            setSelectedRider(selectdRiderItem);
        }
    }, [RiderDetailsList === null || RiderDetailsList === void 0 ? void 0 : RiderDetailsList.data, documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data]);
    useEffect(function () {
        var timer;
        if (isCounterActive && counter > 0) {
            timer = setInterval(function () {
                setCounter(function (prevCounter) { return prevCounter - 1; });
            }, 1000);
        }
        return function () { return clearInterval(timer); };
    }, [isCounterActive, counter]);
    var handleSelectedRider = function () {
        if (riderAssociateCustomerId) {
            var _RiderDetailsList$dat5;
            var selectedRider_1 = RiderDetailsList === null || RiderDetailsList === void 0 || (_RiderDetailsList$dat5 = RiderDetailsList.data) === null || _RiderDetailsList$dat5 === void 0 ? void 0 : _RiderDetailsList$dat5.find(function (item) { return item.id == riderAssociateCustomerId; });
            setSelectedRider(selectedRider_1);
        }
    };
    var handleSelectedVehicle = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload, _result$payload2, _result$payload4, request, result, _result$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!item) return [3 /*break*/, 4];
                    onVehicleSelect(item);
                    setSelectedVehicle(item);
                    request = {
                        InstallBaseId: item === null || item === void 0 ? void 0 : item.InstallBaseId,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: validateDocumentURL,
                            request: request
                        }))];
                case 2:
                    result = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && (result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.value) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.statusCode) === 200) {
                        createUILog({
                            "Body": _objectSpread(_objectSpread({}, request), {}, {
                                "URL": validateDocumentURL,
                                "ParentId": documentId
                            }),
                            "Response": result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.value
                        });
                        setErrorMessage(false);
                        if (SystemName != ESystemName.Appointment) {
                            getRidersList(item === null || item === void 0 ? void 0 : item.InstallBaseId);
                        }
                    }
                    parentDocumentView(item, result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.success);
                    return [3 /*break*/, 5];
                case 4:
                    setSelectedVehicle(_objectSpread(_objectSpread({}, selectedVehicle), {}, {
                        VinNo: ""
                    }));
                    onVehicleSelect(null);
                    if ((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV) {
                        setTechPackPopup({
                            open: false,
                            heading: "",
                            description: "",
                            popupType: "info",
                            declineButton: null,
                            acceptButton: null,
                            onClose: techPackPopup.onClose
                        });
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var parentDocumentView = function (item, isValidateDocument) { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload5, request, result, _result$payload6, parentDocumentData, _response$payload, response, _response$payload2, response, _validateResult$paylo, _validateResult$paylo2, _validateResult$paylo3, validateRequest, validateResult, effectiveToDate, currentDate, diffTime, diffDays;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    request = {
                        InstallBaseId: item === null || item === void 0 ? void 0 : item.InstallBaseId,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        SystemName: SystemName
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "preDocumentFetch",
                            url: PreviousDocumentFetchURL,
                            request: request
                        }))];
                case 2:
                    result = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (!((result === null || result === void 0 || (_result$payload5 = result.payload) === null || _result$payload5 === void 0 || (_result$payload5 = _result$payload5.value) === null || _result$payload5 === void 0 || (_result$payload5 = _result$payload5.data) === null || _result$payload5 === void 0 ? void 0 : _result$payload5.length) > 0)) return [3 /*break*/, 8];
                    parentDocumentData = result === null || result === void 0 || (_result$payload6 = result.payload) === null || _result$payload6 === void 0 || (_result$payload6 = _result$payload6.value) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.data[0];
                    if (!((parentDocumentData === null || parentDocumentData === void 0 ? void 0 : parentDocumentData.PreJobCardDocumentName) == ESystemName.Inspection)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(getDocumentByIdAPIFunction({
                            key: 'documentDetailsGetById',
                            url: "".concat(getVehicleInspectionDetails, "/").concat(parentDocumentData.id, "/Get")
                        }))];
                case 4:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success) {
                        setShowSkeleton(false);
                    }
                    _a.label = 5;
                case 5:
                    if (!((parentDocumentData === null || parentDocumentData === void 0 ? void 0 : parentDocumentData.PreJobCardDocumentName) == ESystemName.Appointment)) return [3 /*break*/, 7];
                    return [4 /*yield*/, dispatch(getDocumentByIdAPIFunction({
                            key: 'documentDetailsGetById',
                            url: "".concat(appointmentDetailsGetByIdAPI).concat(parentDocumentData.id, "/Get")
                        }))];
                case 6:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && (_response$payload2 = _response$payload2.value) !== null && _response$payload2 !== void 0 && _response$payload2.success) {
                        setShowSkeleton(false);
                    }
                    _a.label = 7;
                case 7: return [3 /*break*/, 12];
                case 8:
                    setShowSkeleton(false);
                    if (!(isValidateDocument && (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV)) return [3 /*break*/, 12];
                    validateRequest = {
                        VinNo: item === null || item === void 0 ? void 0 : item.VinNo
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 9:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "validateTechpackExpiry",
                            url: ValidateTechpackExpiryURL,
                            request: validateRequest
                        }))];
                case 10:
                    validateResult = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 11:
                    _a.sent();
                    effectiveToDate = new Date(validateResult === null || validateResult === void 0 || (_validateResult$paylo = validateResult.payload) === null || _validateResult$paylo === void 0 || (_validateResult$paylo = _validateResult$paylo.value) === null || _validateResult$paylo === void 0 ? void 0 : _validateResult$paylo.EffectiveTo);
                    currentDate = new Date();
                    diffTime = effectiveToDate.getTime() - currentDate.getTime();
                    diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    console.log("expiry days difference >>>", diffDays);
                    if (!(validateResult !== null && validateResult !== void 0 && (_validateResult$paylo2 = validateResult.payload) !== null && _validateResult$paylo2 !== void 0 && (_validateResult$paylo2 = _validateResult$paylo2.value) !== null && _validateResult$paylo2 !== void 0 && _validateResult$paylo2.IsExpired) && validateResult !== null && validateResult !== void 0 && (_validateResult$paylo3 = validateResult.payload) !== null && _validateResult$paylo3 !== void 0 && (_validateResult$paylo3 = _validateResult$paylo3.value) !== null && _validateResult$paylo3 !== void 0 && _validateResult$paylo3.ShowPopUp) {
                        setTechPackPopup(_objectSpread(_objectSpread({}, techPackPopup), {}, {
                            open: true,
                            heading: "Tech Pack subscription about to expire!",
                            description: /*#__PURE__*/ React.createElement(React.Fragment, null, "\"Tech Pack subscription is about to expire on ", /*#__PURE__*/ React.createElement("span", {
                                style: {
                                    color: '#000'
                                }
                            }, formatDate(effectiveToDate)), ". Kindly renew the Tech Pack to continue enjoying the benefits"),
                            popupType: "warning",
                            declineButton: null,
                            acceptButton: {
                                text: "Ok",
                                onClick: techPackPopup.onClose,
                                type: "contained",
                                fullWidth: true
                            }
                        }));
                    }
                    _a.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseAddRiderPopup = function () {
        setOpenAddRiderPopup(false);
        setVerifyOtp(false);
        setCounter(timerCount);
        setIsVerified(false);
        setValues(initialFValues);
        setErrors({});
    };
    var handleChangeMobileNo = function (e) {
        var _a, _b;
        var _c = e.target, name = _c.name, value = _c.value;
        var updatedValue = value.replace(REG.nonNumericNumber, '');
        // Limit the number of characters to 10
        updatedValue = updatedValue.slice(0, 10);
        e.target.value = updatedValue;
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = updatedValue,
            _a)));
        if (updatedValue.length === 10) {
            validate((_b = {},
                _b[name] = updatedValue,
                _b));
        }
        setCounter(timerCount);
        setIsCounterActive(false);
        setIsVerified(false);
        setVerifyOtp(false);
    };
    var onChangeOTP = function (event) {
        var _a, _b;
        var updatedValue = event.target.value;
        updatedValue = updatedValue.replace(REG.nonNumericNumber, '');
        updatedValue = updatedValue.slice(0, otpLength);
        event.target.value = updatedValue;
        var name = event.target.name;
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = updatedValue,
            _a)));
        validate((_b = {},
            _b[name] = updatedValue,
            _b));
    };
    var sendOtp = function () {
        setValues(_objectSpread(_objectSpread({}, values), {}, {
            otp: ''
        }));
        getOtp();
    };
    var getOtp = function () { return __awaiter(_this, void 0, void 0, function () {
        var request, otpResponse, _otpResponse$payload, _otpResponse$payload2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        MobileNumber: values.ContactNumber
                        // TemplateId: "RiderOTPVerifyTemplate"   // Static string
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'getOtpNum',
                            url: "".concat(sentOtpUrl),
                            request: request
                        }))];
                case 1:
                    otpResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (otpResponse.payload.value.statusCode === 200) {
                        setVerifyOtp(true);
                        setIsCounterActive(true);
                        setCounter(timerCount);
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("OTP sent successfully"),
                            type: "success"
                        }));
                    }
                    else {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', handleServerSideErrorsForAnalytics(otpResponse === null || otpResponse === void 0 || (_otpResponse$payload = otpResponse.payload) === null || _otpResponse$payload === void 0 ? void 0 : _otpResponse$payload.value));
                        dispatch(showNotification({
                            isOpen: true,
                            message: handleServerSideErrors(otpResponse === null || otpResponse === void 0 || (_otpResponse$payload2 = otpResponse.payload) === null || _otpResponse$payload2 === void 0 ? void 0 : _otpResponse$payload2.value),
                            type: "error"
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onConfirmOtp = function () {
        verifyOtpNum();
    };
    var verifyOtpNum = function () { return __awaiter(_this, void 0, void 0, function () {
        var _verifyotpResponse$pa, request, verifyotpResponse, _verifyotpResponse$pa2, _verifyotpResponse$pa3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        MobileNumber: values.ContactNumber,
                        VerificationCode: values.otp
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'verifyOtp',
                            url: "".concat(verifyOtpUrl),
                            request: request
                        }))];
                case 1:
                    verifyotpResponse = _a.sent();
                    if (verifyotpResponse !== null && verifyotpResponse !== void 0 && (_verifyotpResponse$pa = verifyotpResponse.payload) !== null && _verifyotpResponse$pa !== void 0 && (_verifyotpResponse$pa = _verifyotpResponse$pa.value) !== null && _verifyotpResponse$pa !== void 0 && _verifyotpResponse$pa.success) {
                        setVerifyOtp(false);
                        setIsVerified(true);
                        setCounter(timerCount);
                        setIsCounterActive(false);
                        setRiderVerifiedStatus(true);
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Mobile number verified"),
                            type: "success"
                        }));
                    }
                    else {
                        // setCounter(timerCount);
                        // setIsCounterActive(false)
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', handleServerSideErrorsForAnalytics(verifyotpResponse === null || verifyotpResponse === void 0 || (_verifyotpResponse$pa2 = verifyotpResponse.payload) === null || _verifyotpResponse$pa2 === void 0 ? void 0 : _verifyotpResponse$pa2.value));
                        dispatch(showNotification({
                            isOpen: true,
                            message: handleServerSideErrors(verifyotpResponse === null || verifyotpResponse === void 0 || (_verifyotpResponse$pa3 = verifyotpResponse.payload) === null || _verifyotpResponse$pa3 === void 0 ? void 0 : _verifyotpResponse$pa3.value),
                            type: "error"
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleEmailChange = function (e) {
        var regex = /^[a-zA-Z0-9.\-_+@]+$/;
        var input = e.target.value;
        if (regex.test(input) || input === "") {
            setValues(function (val) { return _objectSpread(_objectSpread({}, val), {}, {
                emailId: input
            }); });
        }
    };
    var onClickConfirm = function (e) {
        e.preventDefault();
        if (validate()) {
            saveRider();
        }
    };
    console.log("ContactPreferrenceList", ContactPreferrenceList.data);
    var saveRider = function () { return __awaiter(_this, void 0, void 0, function () {
        var _selectedVehicle$Inst, _VehiclesDetailsList$3, _values$emailId, _values$language, _response$payload3, _response$payload4, _response$payload5, _response$payload6, request, response, _selectedVehicle$Inst2, _VehiclesDetailsList$4, _values$emailId2, _response$payload$val, _response$payload7, requestBody, _response$payload8, _response$payload9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        InstallBaseId: ((_selectedVehicle$Inst = selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.InstallBaseId) !== null && _selectedVehicle$Inst !== void 0 ? _selectedVehicle$Inst : VehiclesDetailsList) ? (_VehiclesDetailsList$3 = VehiclesDetailsList[0]) === null || _VehiclesDetailsList$3 === void 0 ? void 0 : _VehiclesDetailsList$3.InstallBaseId : '',
                        CustomerId: customerDetails.CustomerId,
                        RelationId: values.relation,
                        GivenName: values.riderFirstName,
                        FamilyName: values.riderLastName,
                        CountryCode: "+91",
                        AlternateName: "NA",
                        MobileNumber: values.ContactNumber,
                        Email: (_values$emailId = values.emailId) !== null && _values$emailId !== void 0 ? _values$emailId : null,
                        LanguageId: (_values$language = values.language) !== null && _values$language !== void 0 ? _values$language : null,
                        // Qualification: "BCA",
                        IsDefaultCommunication: true,
                        CommunicationTypes: values.contactPreferences.map(function (item) { return item.id; })
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'SaveRiderDetails',
                            url: "".concat(VIcreateRiderAPI),
                            request: request
                        }))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (!(((response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.statusCode) === 200 || (response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.value) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.statusCode) === 201) && response !== null && response !== void 0 && (_response$payload5 = response.payload) !== null && _response$payload5 !== void 0 && (_response$payload5 = _response$payload5.value) !== null && _response$payload5 !== void 0 && _response$payload5.success && response !== null && response !== void 0 && (_response$payload6 = response.payload) !== null && _response$payload6 !== void 0 && (_response$payload6 = _response$payload6.value) !== null && _response$payload6 !== void 0 && _response$payload6.data)) return [3 /*break*/, 5];
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Rider saved successfully"),
                        type: "success"
                    }));
                    handleCloseAddRiderPopup();
                    getRidersList(((_selectedVehicle$Inst2 = selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.InstallBaseId) !== null && _selectedVehicle$Inst2 !== void 0 ? _selectedVehicle$Inst2 : VehiclesDetailsList) ? (_VehiclesDetailsList$4 = VehiclesDetailsList[0]) === null || _VehiclesDetailsList$4 === void 0 ? void 0 : _VehiclesDetailsList$4.InstallBaseId : '');
                    requestBody = {
                        PersonContactPoints: [{
                                MobileNo: values.ContactNumber,
                                Email: (_values$emailId2 = values.emailId) !== null && _values$emailId2 !== void 0 ? _values$emailId2 : null,
                                ContactType: "Primary",
                                IsMobileVerified: riderVerifiedStatus
                            }]
                    };
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: 'updateAssociateCustomer',
                            url: "".concat(updateAssociateCustomerAPI((_response$payload$val = response === null || response === void 0 || (_response$payload7 = response.payload) === null || _response$payload7 === void 0 || (_response$payload7 = _response$payload7.value) === null || _response$payload7 === void 0 || (_response$payload7 = _response$payload7.data) === null || _response$payload7 === void 0 ? void 0 : _response$payload7.AssociateCustomerId) !== null && _response$payload$val !== void 0 ? _response$payload$val : "")),
                            request: requestBody
                        }))];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', handleServerSideErrorsForAnalytics(response === null || response === void 0 || (_response$payload8 = response.payload) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.value));
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 || (_response$payload9 = response.payload) === null || _response$payload9 === void 0 ? void 0 : _response$payload9.value),
                        type: "error"
                    }));
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var getRidersList = function (installBaseId) { return __awaiter(_this, void 0, void 0, function () {
        var request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    request = {
                        InstallBaseId: installBaseId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'RiderDetailsList',
                            url: getRiderListByInstallBaseIdUrl,
                            request: request
                        }))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onContactPreferrenceChange = function (e, value) {
        setValues(function (val) { return _objectSpread(_objectSpread({}, val), {}, {
            contactPreferences: value
        }); });
    };
    //RiderDetailsList?.data?.IsMobileVerified
    var riderMasterAPI = function () {
        getLanguagePickList();
        getRelationPickList();
        getContactPreferencePickList();
    };
    var getLanguagePickList = function () { return __awaiter(_this, void 0, void 0, function () {
        var request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ProductId: selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.ProductId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'LanguageList',
                            url: LanguageListAPI,
                            request: request
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getRelationPickList = function () { return __awaiter(_this, void 0, void 0, function () {
        var storedRelationList, _storedRelationList$d, driverRelation, _relationResponse$pay, _relationResponse$pay2, relationResponse, _relationResponse$pay3, _relationResponse$pay4, driverRelation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storedRelationList = getLocalStorageItem(LOCAL_STORAGE_KEYS.RELATION_LIST);
                    if (!(storedRelationList && storedRelationList.data)) return [3 /*break*/, 1];
                    dispatch(setState({
                        key: "RelationList",
                        value: storedRelationList
                    }));
                    driverRelation = (storedRelationList === null || storedRelationList === void 0 || (_storedRelationList$d = storedRelationList.data) === null || _storedRelationList$d === void 0 || (_storedRelationList$d = _storedRelationList$d.find(function (x) { return x.Name === "Driver"; })) === null || _storedRelationList$d === void 0 ? void 0 : _storedRelationList$d.id) || null;
                    setValues(_objectSpread(_objectSpread({}, values), {}, {
                        relation: driverRelation
                    }));
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'RelationList',
                        url: RelationListAPI
                    }))];
                case 2:
                    relationResponse = _a.sent();
                    if (((_relationResponse$pay = relationResponse.payload) === null || _relationResponse$pay === void 0 || (_relationResponse$pay = _relationResponse$pay.value) === null || _relationResponse$pay === void 0 ? void 0 : _relationResponse$pay.statusCode) == 200 && (_relationResponse$pay2 = relationResponse.payload) !== null && _relationResponse$pay2 !== void 0 && (_relationResponse$pay2 = _relationResponse$pay2.value) !== null && _relationResponse$pay2 !== void 0 && _relationResponse$pay2.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.RELATION_LIST, (_relationResponse$pay3 = relationResponse.payload) === null || _relationResponse$pay3 === void 0 ? void 0 : _relationResponse$pay3.value);
                        driverRelation = ((_relationResponse$pay4 = relationResponse.payload) === null || _relationResponse$pay4 === void 0 || (_relationResponse$pay4 = _relationResponse$pay4.value) === null || _relationResponse$pay4 === void 0 || (_relationResponse$pay4 = _relationResponse$pay4.data) === null || _relationResponse$pay4 === void 0 || (_relationResponse$pay4 = _relationResponse$pay4.find(function (x) { return x.Name === "Driver"; })) === null || _relationResponse$pay4 === void 0 ? void 0 : _relationResponse$pay4.id) || null;
                        setValues(_objectSpread(_objectSpread({}, values), {}, {
                            relation: driverRelation
                        }));
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getContactPreferencePickList = function () { return __awaiter(_this, void 0, void 0, function () {
        var storedCommunicationTypeList, _communicationTypesLi, _communicationTypesLi2, _communicationTypesLi3, communicationTypesListResponse, _communicationTypesLi4, _communicationTypesLi5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storedCommunicationTypeList = getLocalStorageItem(LOCAL_STORAGE_KEYS.COMMUNICATION_TYPES_LIST);
                    if (!(storedCommunicationTypeList && storedCommunicationTypeList.data)) return [3 /*break*/, 1];
                    dispatch(setState({
                        key: "ContactPreferrenceList",
                        value: storedCommunicationTypeList
                    }));
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'ContactPreferrenceList',
                        url: VIContactPreferencePickListAPI
                    }))];
                case 2:
                    communicationTypesListResponse = _a.sent();
                    if (communicationTypesListResponse !== null && communicationTypesListResponse !== void 0 && (_communicationTypesLi = communicationTypesListResponse.payload) !== null && _communicationTypesLi !== void 0 && _communicationTypesLi.value && communicationTypesListResponse !== null && communicationTypesListResponse !== void 0 && (_communicationTypesLi2 = communicationTypesListResponse.payload) !== null && _communicationTypesLi2 !== void 0 && (_communicationTypesLi2 = _communicationTypesLi2.value) !== null && _communicationTypesLi2 !== void 0 && _communicationTypesLi2.success && communicationTypesListResponse !== null && communicationTypesListResponse !== void 0 && (_communicationTypesLi3 = communicationTypesListResponse.payload) !== null && _communicationTypesLi3 !== void 0 && (_communicationTypesLi3 = _communicationTypesLi3.value) !== null && _communicationTypesLi3 !== void 0 && _communicationTypesLi3.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.COMMUNICATION_TYPES_LIST, communicationTypesListResponse === null || communicationTypesListResponse === void 0 || (_communicationTypesLi4 = communicationTypesListResponse.payload) === null || _communicationTypesLi4 === void 0 ? void 0 : _communicationTypesLi4.value);
                        dispatch(setState({
                            key: "ContactPreferrenceList",
                            value: communicationTypesListResponse === null || communicationTypesListResponse === void 0 || (_communicationTypesLi5 = communicationTypesListResponse.payload) === null || _communicationTypesLi5 === void 0 ? void 0 : _communicationTypesLi5.value
                        }));
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) == "Create" || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) == "Create" || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) == "Create" && !IsFromParentAPt) && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        bgcolor: systemColor.white,
        px: 1.5,
        border: "1px solid ".concat(systemColor.grey),
        borderRadius: 2,
        spacing: 2,
        py: "12px",
        mt: 2
    }, /*#__PURE__*/ React.createElement(CustomerAndInstallBaseSelect, {
        VehiclesDetailsList: VehiclesDetailsList,
        customerDetails: customerDetails,
        isCheckBoxVisible: isCheckBoxVisible,
        isDisabled: isDisabled,
        parentComponent: parentComponent,
        createAndEditFlow: createAndEditFlow,
        onSelectVehicle: function (item) { return handleSelectedVehicle(item ? item : null); },
        IsFromParentAPt: IsFromParentAPt
    }))
    //   :
    // <CustomerAndVehicleInfo
    //   VehiclesDetailsList={VehiclesDetailsList}
    //   customerDetails={customerDetails}
    //   isCheckBoxVisible={isCheckBoxVisible}
    //   isDisabled={isDisabled}
    //   parentComponent={parentComponent}
    //   createAndEditFlow={createAndEditFlow}
    //   onSelectVehicle={(item: IVehicleDetails) => handleSelectedVehicle(item)}
    //   IsFromParentAPt={IsFromParentAPt} />
    , ((selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.VinNo) || module == APISchema.Estimate || module == APISchema.Inspection) && !errorMessage && /*#__PURE__*/ React.createElement(MuiStack, {
        display: parentComponent === EParentModuleName.Appointment ? 'none' : 'block',
        direction: "column",
        bgcolor: systemColor.white,
        border: "1px solid ".concat(systemColor.grey),
        borderRadius: 2,
        spacing: 2,
        padding: 1,
        mt: 2
    }, parentComponent != EParentModuleName.Appointment && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        checkBoxValue: onClickRider,
        label: t("Rider brought the vehicle"),
        id: "send-notification-to-rider-checkbox",
        disabled: isDisabled,
        handleChange: function () {
            if (!onClickRider) {
                getRidersList(getInstallBaseId);
                setOnClickRider(true);
                handleSelectedRider();
            }
            else {
                setOnClickRider(false);
            }
        }
    }), onClickRider && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, !isDisabled && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, (RiderDetailsList === null || RiderDetailsList === void 0 || (_RiderDetailsList$dat6 = RiderDetailsList.data) === null || _RiderDetailsList$dat6 === void 0 ? void 0 : _RiderDetailsList$dat6.length) > 0 && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        align: "center",
        paddingY: '7px'
    }, t('Select rider/driver'))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "flex-end"
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "add-rider",
        onClick: function () {
            setOpenAddRiderPopup(true);
            riderMasterAPI();
        }
    }, /*#__PURE__*/ React.createElement(AddIcon, {
        sx: {
            stroke: systemColor.primary,
            height: 12,
            width: 12
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        color: systemColor.primary,
        variant: "h3"
    }, t("Add"))))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2,
        paddingY: 1
    }, selectedVehicle || APISchema.Estimate ? /*#__PURE__*/ React.createElement(React.Fragment, null, RiderDetailsList === null || RiderDetailsList === void 0 || (_RiderDetailsList$dat7 = RiderDetailsList.data) === null || _RiderDetailsList$dat7 === void 0 ? void 0 : _RiderDetailsList$dat7.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MuiStack, {
            key: index,
            border: (selectedRider === null || selectedRider === void 0 ? void 0 : selectedRider.id) === item.id ? 2 : 1,
            borderColor: (selectedRider === null || selectedRider === void 0 ? void 0 : selectedRider.id) === item.id ? bajajPrimaryBlue : '#DEE4EB',
            borderRadius: '12px',
            paddingX: 3,
            paddingY: 2,
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            id: "selectBtn",
            onClick: function () {
                if (!isDisabled) {
                    setSelectedRider(item);
                    setRiderAssociateCustomerId(item === null || item === void 0 ? void 0 : item.id);
                    dispatch(setDocDataUpdated(true));
                }
            }
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            control: /*#__PURE__*/ React.createElement(Radio, {
                id: "rider-checkbox",
                sx: {
                    padding: 0
                }
            }),
            label: '',
            checked: (selectedRider === null || selectedRider === void 0 ? void 0 : selectedRider.id) === item.id,
            disabled: isDisabled
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            spacing: 0.5
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement("div", {
            id: "rider-name",
            style: {
                fontSize: "14px",
                fontWeight: "500",
                wordWrap: "break-word",
                textWrap: "pretty",
                color: "#1B1D21",
                overflowWrap: "anywhere"
            }
        }, item.GivenName, " ", item.FamilyName ? item.FamilyName : "-", " ", /*#__PURE__*/ React.createElement("span", {
            id: "rider-type",
            style: {
                color: "#8593A3",
                fontWeight: "400"
            }
        }, item.RelationName ? item.RelationName : "-", " "), " ")), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1,
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "rider-mobile-number",
            variant: "h4",
            color: '#8593A3'
        }, item.MobileNumber ? item.MobileNumber : "-"), (item === null || item === void 0 ? void 0 : item.IsMobileVerified) && /*#__PURE__*/ React.createElement("img", {
            id: "verified-icon",
            src: GreenVerifiedTick,
            alt: "succesicon"
        }))));
    })) : /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 1,
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Select vehicle to see associate riders or add rider.")))), selectedRider && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        checkBoxValue: isSendNotification,
        disabled: !selectedRider,
        label: t("Send notification to rider/driver"),
        handleChange: function () {
            if (!isDisabled) {
                setIsSendNotification(!isSendNotification);
                dispatch(setDocDataUpdated(true));
                // dispatch(setState({ key: "createVehicleInspectionData", value: { ...createVehicleInspectionData, isSendNotification: !isSendNotification } }))
            }
        },
        id: "send-notification-to-rider-checkbox"
    }))), /*#__PURE__*/ React.createElement(MuiPopup, {
        showLoaderOnPopup: true,
        openPopup: openAddRiderPopup,
        closeIcon: true,
        title: t('Add new rider'),
        variant: "h1",
        margin: 0,
        paddingX: "16px",
        containerStyle: {
            width: lgMode ? '600px' : 'calc(90vw)',
            paddingTop: 0
        },
        onClose: handleCloseAddRiderPopup
    }, /*#__PURE__*/ React.createElement(MuiForm, {
        id: "add-new-rider-popup"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: '#8593A3'
    }, t("Please enter details of the new rider")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, {
        sx: {
            '&.MuiInputLabel-root': {
                '&::after': {
                    content: '"*"',
                    color: 'red',
                    marginLeft: '2px'
                }
            }
        }
    }, t('Relation with owner')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "rider-relation-dropdown",
        margin: 0,
        fullWidth: true,
        options: (RelationList === null || RelationList === void 0 ? void 0 : RelationList.data) || [],
        displayExpr: "Name",
        valueExpr: "id",
        name: "relation",
        value: values === null || values === void 0 ? void 0 : values.relation,
        onChange: handleInputChange,
        error: errors === null || errors === void 0 ? void 0 : errors.relation,
        caption: t('RELATION_SELECT_PLACEHOLDER')
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, {
        sx: {
            '&.MuiInputLabel-root': {
                '&::after': {
                    content: '"*"',
                    color: 'red',
                    marginLeft: '2px'
                }
            }
        }
    }, t('First name')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        id: "rider-first-name-input",
        placeholder: t("Enter first name"),
        fullWidth: true,
        size: "small",
        inputProps: {
            maxLength: 50
        },
        value: values === null || values === void 0 ? void 0 : values.riderFirstName,
        name: "riderFirstName",
        onChange: function (e) {
            var input = e.target.value;
            if (/^[a-zA-Z]*$/.test(input) || input === '') {
                setValues(function (val) { return _objectSpread(_objectSpread({}, val), {}, {
                    riderFirstName: input
                }); });
            }
        },
        error: errors === null || errors === void 0 ? void 0 : errors.riderFirstName
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, {
        sx: {
            '&.MuiInputLabel-root': {
                '&::after': {
                    content: '"*"',
                    color: 'red',
                    marginLeft: '2px'
                }
            }
        }
    }, t('Last name')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        id: "rider-last-name-input",
        placeholder: t("Enter last name"),
        inputProps: {
            maxLength: 50
        },
        fullWidth: true,
        size: "small",
        value: values === null || values === void 0 ? void 0 : values.riderLastName,
        name: "riderLastName",
        onChange: function (e) {
            var input = e.target.value;
            if (/^[a-zA-Z]*$/.test(input) || input === '') {
                setValues(function (val) { return _objectSpread(_objectSpread({}, val), {}, {
                    riderLastName: input
                }); });
            }
        },
        error: errors === null || errors === void 0 ? void 0 : errors.riderLastName
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, {
        sx: {
            '&.MuiInputLabel-root': {
                '&::after': {
                    content: '"*"',
                    color: 'red',
                    marginLeft: '2px'
                }
            }
        }
    }, t('Mobile No.')), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputBox, {
        id: "rider-mobileNo-input",
        placeholder: t("Enter mobile no."),
        size: "small",
        fullWidth: true,
        value: values === null || values === void 0 ? void 0 : values.ContactNumber,
        name: "ContactNumber",
        onChange: handleChangeMobileNo,
        error: errors === null || errors === void 0 ? void 0 : errors.ContactNumber,
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*'
        },
        InputProps: {
            endAdornment: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Divider, {
                sx: {
                    height: 38,
                    m: 0
                },
                orientation: "vertical"
            }), !verifyOtp && !isVerified ? /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "end",
                style: {
                    width: '100px',
                    display: 'flex',
                    alignItems: 'center'
                }
            }, /*#__PURE__*/ React.createElement(MuiButton, {
                id: "send-otp-btn",
                name: t("Send OTP"),
                variant: "text",
                size: "medium",
                onClick: sendOtp,
                disabled: !(values !== null && values !== void 0 && values.ContactNumber) || (values === null || values === void 0 ? void 0 : values.ContactNumber.length) !== 10 || (values === null || values === void 0 ? void 0 : values.ContactNumber.charAt(0)) === '0'
            })) : isVerified ? /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "end",
                style: {
                    width: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }
            }, /*#__PURE__*/ React.createElement("img", {
                src: GreenVerifiedTick,
                alt: "succesicon"
            })) : /*#__PURE__*/ React.createElement("div", null, counter <= 0 ? /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "end",
                style: {
                    width: '100px',
                    display: 'flex',
                    alignItems: 'center'
                }
            }, /*#__PURE__*/ React.createElement(MuiButton, {
                id: "resend-otp-btn",
                name: t("Resend OTP"),
                variant: "text",
                size: "medium",
                onClick: sendOtp,
                disabled: !(values !== null && values !== void 0 && values.ContactNumber && !["0"].includes(values === null || values === void 0 ? void 0 : values.ContactNumber.charAt(0)))
            })) : /*#__PURE__*/ React.createElement("div", {
                style: {
                    width: '60px'
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3",
                id: "otp-counter",
                align: "center",
                color: bajajPrimaryBlue
            }, formatTime(counter)))))
        }
    }), verifyOtp && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, {
        sx: {
            '&.MuiInputLabel-root': {
                '&::after': {
                    content: '"*"',
                    color: 'red',
                    marginLeft: '2px'
                }
            }
        }
    }, t('OTP')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        id: "otp-dropdown",
        placeholder: t("Enter received OTP"),
        fullWidth: true,
        size: "small",
        value: values === null || values === void 0 ? void 0 : values.otp,
        name: "otp",
        onChange: onChangeOTP,
        error: errors === null || errors === void 0 ? void 0 : errors.otp,
        disabled: !verifyOtp,
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*'
        },
        InputProps: (values === null || values === void 0 ? void 0 : values.otp) && (values === null || values === void 0 ? void 0 : values.otp.length) === parseInt(otpLength) && {
            endAdornment: /*#__PURE__*/ React.createElement(MuiButton, {
                name: t("Confirm"),
                variant: "text",
                id: "onConfirmClick",
                onClick: onConfirmOtp
            })
        }
    }))))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, null, t('Email address')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        id: "rider-email-input",
        placeholder: t("Enter email address"),
        fullWidth: true,
        size: "small",
        value: values === null || values === void 0 ? void 0 : values.emailId,
        name: "emailId",
        onChange: handleEmailChange,
        error: errors.emailId
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, null, t('Language preferred')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "rider-language-dropdown",
        margin: 0,
        fullWidth: true,
        caption: t('LANGUAGE'),
        name: "language",
        value: values === null || values === void 0 ? void 0 : values.language,
        displayExpr: "Name",
        valueExpr: "id",
        onChange: handleInputChange,
        error: errors === null || errors === void 0 ? void 0 : errors.language,
        options: (LanguageList === null || LanguageList === void 0 ? void 0 : LanguageList.data) || []
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, null, t('Contact preference')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Autocomplete, {
        multiple: true,
        id: "multiple-contact-preference-dropdown",
        options: (_ContactPreferrenceLi = ContactPreferrenceList === null || ContactPreferrenceList === void 0 ? void 0 : ContactPreferrenceList.data) !== null && _ContactPreferrenceLi !== void 0 ? _ContactPreferrenceLi : [],
        getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.Name) || ''; },
        isOptionEqualToValue: function (option, value) { return (option === null || option === void 0 ? void 0 : option.id) === (value === null || value === void 0 ? void 0 : value.id); },
        value: values.contactPreferences,
        onChange: onContactPreferrenceChange,
        disablePortal: true // helps inside modal/drawer
        ,
        renderInput: function (params) {
            var _values$contactPrefer;
            return /*#__PURE__*/ React.createElement(TextField, _extends({}, params, {
                placeholder: ((_values$contactPrefer = values.contactPreferences) === null || _values$contactPrefer === void 0 ? void 0 : _values$contactPrefer.length) === 0 ? t('SELECT_CONTACT_PREF_PLACEHOLDER') : '',
                size: "small",
                error: !!(errors !== null && errors !== void 0 && errors.contactPreferences)
            }));
        }
        // renderTags={(value, getTagProps) =>
        //   value.map((option: any, index: number) => (
        //     <Chip
        //       label={option?.Name}
        //       {...getTagProps({ index })}
        //       size="small"
        //       variant="outlined"
        //       deleteIcon={<CloseIcon />}
        //     />
        //   ))
        // }
        // ChipProps={{
        //   shape: 'rounded',
        //   variant: 'outlined',
        //   size: 'small',
        //   deleteIcon: <CloseIcon />,
        // }}
        ,
        size: "small",
        sx: {
            width: '100%',
            '& .MuiAutocomplete-popper': {
                zIndex: 2000 // ensure it's above modals if needed
            }
        }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1.5,
        direction: "column",
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "large",
        fullWidth: true,
        variant: "contained",
        name: t("Confirm"),
        disabled: !(values.relation && values.riderFirstName && values.riderLastName && values.ContactNumber && isVerified),
        id: "confirmButton",
        onClick: onClickConfirm
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        size: "large",
        fullWidth: true,
        variant: "outlined",
        id: "cancelButton",
        name: t("Cancel"),
        style: {
            borderColor: '#DEE4EB',
            color: '#6A7682'
        },
        onClick: handleCloseAddRiderPopup
    }))))))), (selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.VinNo) && !errorMessage && /*#__PURE__*/ React.createElement(ServiceDetailsComponent, {
        vehicleDetails: selectedVehicle,
        customerDetails: customerDetails,
        SystemName: SystemName,
        validateDocumentURL: validateDocumentURL
        // errorMessage={errorMessage}
        ,
        createDocumentURL: createDocumentURL,
        parentComponent: parentComponent,
        apiRequestPayload: apiRequestPayload,
        module: module,
        parentModuleDocumentId: parentModuleDocumentId,
        riderAssociateCustomerId: riderAssociateCustomerId,
        isDisabled: isDisabled,
        onSuccessfullDocumentCreate: function (documentCreateResponse) {
            if (onSuccessfullDocumentCreate) {
                onSuccessfullDocumentCreate(documentCreateResponse);
            }
        },
        modifyDocumentURL: modifyDocumentURL,
        createAndEditFlow: createAndEditFlow,
        IsFromParentAPt: IsFromParentAPt,
        VehiclesDetailsList: VehiclesDetailsList[0]
    }), techPackPopup.open && /*#__PURE__*/ React.createElement(TechPackPopup, {
        open: techPackPopup.open,
        onClose: techPackPopup.onClose,
        heading: techPackPopup.heading,
        description: techPackPopup.description,
        popupType: techPackPopup.popupType,
        declineButton: techPackPopup.declineButton,
        acceptButton: techPackPopup.acceptButton
    }));
}
